export default "__VITE_ASSET__ByZWh$XQ__"